<script>
  import { operationStore, query } from "@urql/svelte";
  import { Teilnehmerkongresssmsservice } from "../../Api/congress";
  import { Button, RadioGroup, Textfield } from "../../../Components";
  import toast from "svelte-french-toast";

  const requestPolicy = "network-only";

  export let congressId;

  let teilnehmerkongresssmsserviceData = [];

  let inProgressTeilnehmersmsservice = false;

  let smsStatus;
  let smsMobilnumber = "";

  const congressTeilnehmersmsservice = operationStore(Teilnehmerkongresssmsservice, { congressId }, { requestPolicy });

  query(congressTeilnehmersmsservice);

  congressTeilnehmersmsservice.subscribe((storeObjTeilnehmersmsservice) => {
    inProgressTeilnehmersmsservice = storeObjTeilnehmersmsservice.fetching;
    if (!inProgressTeilnehmersmsservice && storeObjTeilnehmersmsservice.data) {
      teilnehmerkongresssmsserviceData = storeObjTeilnehmersmsservice.data.Teilnehmerkongresssmsservice;

      smsStatus = teilnehmerkongresssmsserviceData.sms_status;
      smsMobilnumber = teilnehmerkongresssmsserviceData.sms_nummer;
    }
  });

  function handleSaveSmsService() {
    congressTeilnehmersmsservice.variables.action = "saveSmsService";
    congressTeilnehmersmsservice.variables.sms_status = smsStatus;
    congressTeilnehmersmsservice.variables.sms_nummer = smsMobilnumber;

    congressTeilnehmersmsservice.reexecute();
    toast.success("Datenänderung wurde übermittelt", { duration: 5000 });
    congressTeilnehmersmsservice.variables.action = "";
  }
</script>

<p>Wenn Sie die SMS-Benachrichtigung unter Bekanntgabe Ihrer Mobilnummer aktivieren, erhalten Sie 10 Minuten vor Beginn Ihrer gebuchten Gruppengespräche ein Erinnerungs-SMS.</p>

<section>
  <form class="not-prose" on:submit|preventDefault={handleSaveSmsService}>
    <strong>SMS-Benachrichtigung:</strong>
    <RadioGroup
      bind:group={smsStatus}
      options={[
        { value: 1, label: "Ja" },
        { value: 2, label: "Nein" },
      ]}
    />
    {#if smsStatus == 1}
      <Textfield label="Mobilnummer" required bind:value={smsMobilnumber} />
    {/if}

    <Button type="submit" main>Speichern</Button>
  </form>
</section>
